<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("blocks.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  clearable
                  single-line
                  hide-details
                  @input="sessionStorage(search)"
                ></v-text-field>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  class="primary"
                  @click="
                    addFlatDialog = true;
                    flat = {};
                  "
                >
                  <v-icon left> mdi-plus </v-icon>
                  Add Block
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table :headers="headers" :items="flats" :search="search">
            <template v-slot:item.actions="{ item }">
              <v-btn
                color="secondary"
                icon
                style="margin-left: -10px"
                @click="
                  addFlatDialog = true;
                  getFlatDetail(item.id, item.name);
                "
              >
                <img src="@/components/icons/edit-02.svg" width="18" height="18" />
              </v-btn>
              <v-btn
                icon
                color="secondary"
                name="delete_flat"
                title="Delete Flat"
                @click="confirmDelete(item.id)"
              >
                <img src="@/components/icons/delete-01.svg" width="18" height="18" />
              </v-btn>
            </template>
          </v-data-table>

        </v-card>
      </v-flex>
      <v-dialog
        v-model="addFlatDialog"
        max-width="450"
        @click:outside="closeDialog"
      >
        <v-card>
          <v-card-title class="text-h5">
            {{ flat.id ? "Edit" : "Add" }} Block
          </v-card-title>
          <v-card-text class="pa-5">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="flat.name"
                  name="Block name"
                  id="name"
                  label="Block Name"
                  v-validate="'required'"
                  :error="
                    errors.first('Block name') != null ||
                    serverSideErrors.name != null
                  "
                  :error-messages="
                    errors.first('Block name') || serverSideErrors.name
                  "
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">
              cancel
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateFlat(flat.id)"
              v-if="flat.id"
            >
              Update
            </v-btn>
            <v-btn color="blue darken-1" text @click="saveFlat" v-else>
              save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteFlat(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("blocks.headers.block_name")}`,
          value: "name",
          width: "85%",
        },
        {
          text: `${this.$t("blocks.headers.actions")}`,
          value: "actions",
          sortable: false,
          width: "15%",
        },
      ],
      user: {},
      addFlatDialog: false,
      editFlatDialog: false,
      deleteDialog: false,
      serverSideErrors: [],
      delete_id: "",
      flats: [],
      flat: {
        name: "",
      },
    };
  },
  watch: {
    addFlatDialog() {
      if (!this.addFlatDialog) {
        this.errors = [];
      }
    },
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getFlats() {
      let _self = this;
      _self.$axios.get("societyadmin/flats").then((response) => {
        let data = response.data;
        if (data.status) {
          _self.flats = data.flats;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
          if (data.type == "invalid") {
            localStorage.removeItem("user");
            _self.$router.push({ path: "/societyadmin/login" });
          }
        }
      });
    },
    deleteFlat(flatId) {
      let _self = this;
      _self.$axios.delete("societyadmin/flats/" + flatId).then((response) => {
        let data = response.data;

        if (data.status) {
          this.flats = this.flats.filter((record) => {
            if (record.id != flatId) {
              return record;
            }
          });
          this.deleteDialog = false;
          this.delete_id = "";
          this.setAlert({
            showAlert: true,
            variant: "green accent-4",
            timeout: "2000",
            message: data.message,
          });
        } else {
          this.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
           this.deleteDialog = false;
           this.delete_id = "";
        }
      });
    },
    saveFlat() {
      let _self = this;
      this.$validator.validateAll().then((success) => {
        if (success) {
          _self.flat.society_id = _self.user.id;
          this.$axios
            .post("/societyadmin/flats", _self.flat)
            .then((response) => {
              let data = response.data;
              if (data.status) {
                this.closeDialog();
                this.getFlats();

              } else {
                if (data.errors) {
                  _self.serverSideErrors = {};
                  for (let i = 0; i < data.errors.length; i++) {
                    _self.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                } else {
                  _self.setAlert({
                    showAlert: true,
                    variant: "red accent-3",
                    timeout: "2000",
                    message: data.message,
                  });
                }
              }
            });
        }
        // submit the value
      });
    },
    updateFlat(id) {
      let _self = this;
      this.$validator.validateAll().then((success) => {
        if (success) {
          _self.flat.society_id = _self.user.id;
          this.$axios
            .put("/societyadmin/flats/" + id, _self.flat)
            .then((response) => {
              let data = response.data;
              if (data.status) {
                // add module to the array
                this.getFlats();
                this.closeDialog();
              } else {
                if (data.errors) {
                  _self.serverSideErrors = {};
                  for (let i = 0; i < data.errors.length; i++) {
                    _self.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                } else {
                  _self.setAlert({
                    showAlert: true,
                    variant: "red accent-3",
                    timeout: "2000",
                    message: data.message,
                  });
                }
              }
            });
        }
        // submit the value
      });
    },
    closeDialog() {
      this.deleteDialog = false;
      this.addFlatDialog = false;
      this.flat = {};
      this.$validator.reset();
      this.serverSideErrors = [];
    },
    getFlatDetail(id, name) {
      this.flat.id = id;
      this.flat.name = name;
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("flat_search");
      } else {
        sessionStorage.setItem("flat_search", search);
      }
    },
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};

    this.getFlats();
    this.search = sessionStorage.getItem("flat_search");
  },
};
</script>